"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const deserializeNumber_1 = require("./deserializeNumber");
function deserializeLatitude(value) {
    return (0, deserializeNumber_1.deserializeNumber)(value, -90, 90);
}
exports.default = deserializeLatitude;
